import moment from 'moment'
export function dateFormat (input,fmtstring) {
    if(input){
        return moment(input).format(fmtstring);
    }else{
        return "";
    }
}